module.exports = __webpack_public_path__ + "static/media/alucio_logo.16924a97.png";